import React, { useState } from "react";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomTable from "../../../components/main_comps/custom_table";
import {
  VanAllCustomerHeaders,
  couponServiceHeaders,
} from "../../../../utility/TableHeaders";

import { showHideFilterModalReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import MainComponent from "../../../components/ui_comps/MainComponent";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import { useDispatch } from "react-redux";
import ResizeListner from "../../../../utility/ResizeListner";
import { setHeaders } from "../../../../services/aclValidateServiceTable";
import { CustomButton } from "../../../components/main_comps/custom_button";

const FilterComponent = ({ onChange, onPress }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <CustomButton
        title="Download Report"
        backgroundColor="#38369C"
        onClick={onPress}
      />
    </div>
  );
};

const CouponIndex = () => {
  const role = secureStorage.getItem(SS_ROLE);
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const { width, height } = ResizeListner();
  const [reportModal, setReportModal] = useState(false);
  const dispatch = useDispatch();

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        onClickFilter={() => {
          dispatch(
            showHideFilterModalReducer({
              showFilterModal: true,
              filters: [
                "dateRange",
                "clientName",
                "resellerName",
                "email",
                "mobileNumber",
                "vanNumber",
                "status",
              ],
            })
          );
        }}
        onClickFilterCall={() => {}}
        filterRequired={true}
        headerTitle="Customers"
      />
      <div style={{ display: "flex", justifyContent: "right", margin: "10px" }}>
        <FilterComponent onPress={() => setReportModal(true)} />
      </div>

      <div style={{ padding: "0px 20px", overflow: "hidden" }}>
        <CustomTable
          styles={{
            maxHeight: height * 0.7,
            minHeight: height * 0.7,
          }}
          headers={setHeaders(couponServiceHeaders, role)}
        />
      </div>

      {reportModal && (
        <CustomModal
          headerTitle="Download Report"
          open={reportModal}
          onClose={() => {
            setReportModal(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        ></CustomModal>
      )}
    </div>
  );
};

export default CouponIndex;
